export const appVolumePurchaseCodes = {
    read(appId, idOrOptions) {
        return $.getJSON(AdminRoutes.adminAppVolumePurchaseCodesPath(appId, idOrOptions))
    }
}